import HttpClient from '../utils/http-client';
import { firstValueFrom } from 'rxjs';

const getClient = () => {
  const uid = localStorage.getItem('user_uid') || '';
  const cid = localStorage.getItem('cid');
  return new HttpClient(uid, cid);
};

export async function getMarketplacePackages(page = 1, limit = 10): Promise<any> {
  try {
    const client = getClient();
    const result = await firstValueFrom(
      client.get<any>(`/marketplace/catalog/packages?page=${page}&limit=${limit}`)
    );
    return result;
  } catch (error) {
    console.error('Error fetching marketplace packages:', error);
    throw error;
  }
}

export async function purchaseMarketplacePackage(marketplacePackageId: number): Promise<{
  success: boolean;
  data?: {
    init_point?: string;
    preference_id?: string;
    marketplace_package_id?: number;
    package_name?: string;
    price?: number;
    id?: number;
    quantity?: number;
    used?: number;
  };
  message?: string;
}> {
  try {
    const client = getClient();
    const result = await firstValueFrom(
      client.post<any>('/marketplace/users/me/packages', {
        marketplace_package_id: marketplacePackageId
      })
    );
    return result;
  } catch (error) {
    console.error('Error purchasing marketplace package:', error);
    throw error;
  }
}
